import styled from 'styled-components';

export const HighlightedText = styled.span<{ capitalize?: boolean }>`
  color: ${({ theme }) => theme.colors.blackBase};

  ${({ capitalize }) =>
    capitalize &&
    `
    text-transform: capitalize;
  `}
`;
